import { Autocomplete, TextField, Typography, Box, Grid } from "@mui/material";
import React, { useEffect } from "react";
import {
  showWarningSnackbar,
} from "../../../components/snackBar/snakbar";
import { MoneyFormatv2, MoneyFormatv3 } from "../../../library/MoneyFormat";

function SelectVoucher({
  items,
  editedItems,
  paymentNo,
  invNo,
  setEditedItems,
  data,
  setData,
}) {
  const cleanNumber = (value) => {
    return Number(value.replace(/[^\d.-]/g, ""));
  };
  function handleLinkedAmount(value) {
    if (value <= Number(editedItems.paymentAmount)) {
      setEditedItems((prev) => ({
        ...prev,
        invoiceBalanceAmount: Number(editedItems.invoiceAmount) - Number(value),
        unlinkedPaymentAmount:
          Number(editedItems.paymentAmount) - Number(value),
      }));
    } else {
      data?.accountName?.AccountGroupID === 7
        ? showWarningSnackbar(
            "Allocated  Amount should not be greater than Receipt Amount"
          )
        : showWarningSnackbar(
            "Allocated  Amount should not be greater than Payment Amount"
          );
      setEditedItems((prev) => ({
        ...prev,
        linkedAmount: Number(editedItems.paymentAmount),
        invoiceBalanceAmount:
          Number(editedItems.invoiceAmount) - Number(editedItems.paymentAmount),
        unlinkedPaymentAmount:
          Number(editedItems.paymentAmount) - Number(editedItems.paymentAmount),
      }));
    }
  }
  function setTotalAmounts() {
    let totInvBal = 0;
    let totPaBal = 0;
    items.map((ele) => {
      totInvBal += Number(ele.invoiceBalanceAmount);
      totPaBal += Number(ele.unlinkedPaymentAmount);
    });
    setData((prev) => ({
      ...prev,
      unlinkedInvAmount: Number(totInvBal),
      unlinkedPayAmount: Number(totPaBal),
    }));
  }

  useEffect(() => {
    setTotalAmounts();
  },[items]);

  return (
    <Box>
      <Box
        sx={{
          borderRadius: "8px",
          backgroundColor: "background.paper",
          marginBottom: "10px",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          padding: { xs: "10px 0px", sm: "10px 10px" },
          borderRadius: "8px",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={12} lg={4} md={12}>
            <Typography
              variant="h4"
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  width: "80px",
                  textAlign: "center",
                  marginRight: "30px",
                }}
              >
               {data.AccountGroupID===7 ?"Voucher Number":"Invoice Number"}
              </span>
              <span
                style={{
                  width: "80px",
                  textAlign: "center",
                  marginRight: "30px",
                }}
              >
               {data.AccountGroupID===7 ? "Voucher Date":"Invoice Date"}
              </span>
              <span
                style={{
                  width: "80px",
                  textAlign: "right",
                  marginRight: "30px",
                }}
              >
              {data.AccountGroupID===7 ?  "Voucher Amount (₹)":"Invoice Amount (₹)"}
              </span>
              <span style={{ width: "80px", textAlign: "right",marginLeft:"30px" }}>
              {data.AccountGroupID===7 ? "Voucher Balance (₹)" :"Invoice Balance (₹)"}
              </span>
            </Typography>
            <Autocomplete
              disableClearable
              disablePortal
              options={invNo}
              value={editedItems?.invoiceNumber}
              size="small"
              name="invoiceNumber"
              id="invoiceNumber"
              fullWidth
              onChange={(e, newValue) => {
                if (newValue) {
                  setEditedItems((prev) => ({
                    ...prev,
                    invoiceNumber: newValue,
                    date: newValue.date,
                    invoiceAmount: Number(newValue.invAmt),
                    invoiceBalanceAmount:
                      Number(newValue.invAmt) -
                      Number(editedItems.linkedAmount),
                  }));
                }
              }}
              isOptionEqualToValue={(option, value) => option == value}
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  
                />
              )}
            />
          </Grid>
          <Grid item xs={12} lg={4} md={12}>
          <Typography
              variant="h4"
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  width: "80px",
                  textAlign: "center",
                  marginRight: "30px",
                }}
              >
               {data.AccountGroupID===7 ?"Payment Number":"Receipt Number"}
              </span>
              <span
                style={{
                  width: "80px",
                  textAlign: "center",
                  marginRight: "30px",
                }}
              >
               {data.AccountGroupID===7 ? "Payment Date":"Receipt Date"}
              </span>
              <span
                style={{
                  width: "80px",
                  textAlign: "right",
                  marginRight: "30px",
                }}
              >
              {data.AccountGroupID===7 ?  "Payment Amount (₹)":"Receipt Amount (₹)"}
              </span>
              <span style={{ width: "80px", textAlign: "right",marginLeft:"30px" }}>
              {data.AccountGroupID===7 ? "Payment Balance (₹)" :"Receipt Balance (₹)"}
              </span>
            </Typography>
            <Autocomplete
              disableClearable
              disablePortal
              options={paymentNo}
              value={editedItems?.paymentNumber}
              name="paymentNumber"
              id="paymentNumber"
              size="small"
              fullWidth
              option={paymentNo}
              onChange={(e, newValue) => {
                if (newValue) {
                  setEditedItems((prev) => ({
                    ...prev,
                    paymentNumber: newValue,
                    paymentAmount: newValue.payAmt,
                    unlinkedPaymentAmount:
                      Number(newValue.payAmt) -
                      Number(editedItems.linkedAmount),
                  }));
                }
              }}
              isOptionEqualToValue={(option, value) => option == value}
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} lg={1} md={2}>
            <Typography
              variant="h4"
              sx={{
                width: "100px",
                textAlign: "center",
              }}
            >
              Allocated Amount (₹)
            </Typography>
            <TextField
              size="small"
              fullWidth
              name="linkedAmount"
              id="linkedAmount"
              type="text"
              value={MoneyFormatv2(editedItems?.linkedAmount)}
              onChange={(e) => {
                let value = e.target.value;
                value = value.replace(/,/g, "");
                if (!/^\d*(?:\.\d*)?$/.test(value)) {
                  return;
                }
                if (value > 0 && value <= Number(editedItems.paymentAmount)) {
                  handleLinkedAmount(value);
                  setEditedItems((prev) => ({
                    ...prev,
                    linkedAmount: value,
                  }));
                } else {
                  setEditedItems((prev) => ({
                    ...prev,
                    linkedAmount: 0,
                  }));
                  handleLinkedAmount(value);
                }
              }}
              sx={{ width: 120 }}
              InputProps={{
                inputProps: {
                  style: {
                    textAlign: "right",
                    paddingRight: "5px",
                  },
                  min: 0,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} lg={1.5} md={2}>
            <Typography  sx={{
                width: "100px",
                textAlign: "center",
              
              }} variant="h4">Unlinked Payment (₹)</Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                padding: "8px",
                borderRadius: "4px",
                backgroundColor: "#FFF",
                border: "2px solid rgba(224, 224, 224, 1)",
                position: "relative",
                height: 16,
              }}            >
              <Typography sx={{ color: "#808080" }}>
                <span  >
                  {cleanNumber(
                    MoneyFormatv3(
                      Number(editedItems?.unlinkedPaymentAmount).toFixed(2)
                    )
                  )}
                </span>
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} lg={1.5} md={2}>
            <Typography  sx={{
                width: "120px",
                textAlign: "center",
              }} variant="h4" >
              Unlinked Purchase (₹)
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                padding: "8px",
                borderRadius: "4px",
                backgroundColor: "#FFF",
                border: "2px solid rgba(224, 224, 224, 1)",
                position: "relative",
                height: 16,
              }}
            >
              <Typography sx={{ color: "#808080" }}>
                <span>
                  {cleanNumber(
                    MoneyFormatv3(
                      Number(editedItems?.invoiceBalanceAmount).toFixed(2)
                    )
                  )}
                </span>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default SelectVoucher;
